exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".subtitle-container{width:100%;display:flex;flex-direction:row;align-content:center;justify-content:flex-start;align-items:center;color:#733FBD}.subtitle-container .subtitle-icon{margin-right:5px;display:flex;flex-direction:row;align-content:center;justify-content:flex-start;align-items:center}.subtitle-container .subtitle-text{font-family:'SF-Pro-Display-Medium';font-size:14px;text-transform:uppercase}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss"}!./src/components/Subtitle/style.scss
// module id = 1543
// module chunks = 0